import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";

export default function NotFoundPage() {
  useEffect(() => {
    document.title = "Page not found - Goldmap EA";
  }, []);

  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center px-4 text-center"
      style={{ background: "var(--gm-navy-950)" }}
      data-testid="not-found-page"
    >
      <img
        src="/goldmap-logo.png"
        alt="Goldmap EA"
        width={64}
        height={64}
        className="rounded-full"
        style={{ border: "1px solid rgba(255,255,255,0.25)" }}
      />
      <h1 className="mt-6 font-display text-3xl font-extrabold text-white">404</h1>
      <p className="mt-2 max-w-sm text-sm" style={{ color: "var(--gm-muted)" }}>
        This page tak ada. Maybe the link is old, or you typed it wrong.
      </p>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="gm-btn-red mt-6 inline-flex min-h-[48px] items-center gap-2 rounded-xl px-5 text-sm font-bold"
      >
        <Home className="h-4 w-4" />
        Back to home
      </Link>
    </div>
  );
}
